export const VALIDATORS = {
  "name": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập tên người dùng"
    }
  ],
  "email": [
    {
      errorName: "email",
      errorDescription: "Email không hợp lệ"
    }
  ],
  "phoneNumber": [
    {
      errorName: "pattern",
      errorDescription: "Số điện thoại không hợp lệ"
    }
  ],
  "oldPassword": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập mật khẩu"
    }
  ],
  "newPassword": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập mật khẩu"
    },
    {
      errorName: "pattern",
      errorDescription: "Mật khẩu phải có ký tự đặc biệt, chữ viết thường, viết hoa và số ít nhất 8 ký tự"
    },
    {
      errorName: "minlength",
      errorDescription: "Ít nhất 6 ký tự"
    },
  ],
  "confirmPassword": [
    {
      errorName: "required",
      errorDescription: "Yêu cầu nhập lại mật khẩu"
    },
    {
      errorName: "notMatch",
      errorDescription: "Mật khẩu không khớp"
    },
    {
      errorName: "minlength",
      errorDescription: "Ít nhất 6 ký tự"
    },
  ]
}
